import { GridCellProps } from '@progress/kendo-react-grid';
import ProfileCell from '../flyouts/ProfileCell';

function ProfileNameCell({ dataItem }: GridCellProps) {
  return <ProfileCell dataItem={dataItem} selectedTab={0} />;
}

export default ProfileNameCell;
